import AboutAccreditationsTabs from "./AboutAccreditationsTabs";
import Header from "~/components/Header";
import SectionContainer from "~/components/SectionContainer";

const AboutAccreditations = () => {
	return (
		<SectionContainer
			id="accreditations"
			className="scroll-m-10 border-b bg-white dark:border-slate-600 dark:bg-slate-800"
			aria-label="accreditations-title"
		>
			<div className="mx-auto flex max-w-screen-xl flex-col gap-8 text-center">
				<Header
					title="Accreditations & Approvals"
					description=""
					id="partnerships"
				/>

				<AboutAccreditationsTabs />
			</div>
		</SectionContainer>
	);
};

export default AboutAccreditations;
